import { OctagramMinusOutlineIcon } from './OctagramMinusOutlineIcon';

/**
 * author: Jeff Anders
 * id E11403C7-999F-4EEF-BD97-5598280C54A2
 * name octagram-minus-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/octagram-minus-outline.svg
 * tags
 * - Shape 
 */
export const StarburstMinusOutlineIcon = OctagramMinusOutlineIcon;
export default StarburstMinusOutlineIcon